import {IOpenAppData} from "@sparkware/uc-sdk-core";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import {ICasinofiedComponentFactory} from "../../casinofied-app-factory.interfaces";
import {CasinofiedAppSdkLoader} from "../../casinofied-app-sdk-loader";
import {InsideDrawerApplication} from "../inside-drawer.application";

export class RegistrationWidget extends InsideDrawerApplication {
    public constructor(openAppData: IOpenAppData,
        componentFactory: ICasinofiedComponentFactory,
        appSdkLoader: CasinofiedAppSdkLoader,
        services: IServiceFactoryExtended) {
        super(openAppData, componentFactory, appSdkLoader, services, false);
    }

    protected _isAnonymousModeAllowed(): boolean {
        return true;
    }

    get supportsCloseIntent(): boolean {
        if(this.isLoading) {
            return false;
        }

        return true;
    }
}